import React from 'react';
import { useCurrencies, useCommodities } from './useMarketData'; // Adjust path if needed

const DataRow = ({ label, subLabel, price, change, isPositive, theme }) => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    padding: '0.75rem',
    background: 'rgba(255,255,255,0.03)',
    borderRadius: '8px',
    border: '1px solid rgba(255,255,255,0.05)',
    marginBottom: '0.5rem'
  }}>
    <div>
      <span style={{ fontWeight: 600, color: theme.textPrimary, fontSize: '0.9rem', display: 'block' }}>
        {label}
      </span>
      <span style={{ fontSize: '0.7rem', color: theme.textSecondary }}>
        {subLabel}
      </span>
    </div>
    <div style={{ textAlign: 'right' }}>
      <div style={{ fontFamily: 'monospace', fontSize: '0.9rem', color: theme.textPrimary }}>
        {price}
      </div>
      <div style={{ 
        fontSize: '0.75rem', 
        fontWeight: 600, 
        color: isPositive ? '#4ade80' : '#ef4444' 
      }}>
        {change}
      </div>
    </div>
  </div>
);

// MOEDAS CARD - Currency pairs focused
export const MoedasCard = ({ theme, limit }) => {
  const { data, loading } = useCurrencies();

  if (loading) return <div style={{ height: '300px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }} />;
  if (!data) return <div>No currency data</div>;

  const mainPairs = data
    .filter(c => ['USDBRL', 'EURBRL', 'GBPBRL', 'JPYBRL', 'CNYBRL', 'ARSBRL'].includes(c.symbol))
    .slice(0, limit || 6);

  return (
    <div style={{
      background: theme.cardBg,
      borderRadius: '12px',
      padding: '1.5rem',
      border: `1px solid ${theme.border}`,
      backdropFilter: 'blur(10px)',
      height: '100%'
    }}>
      <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#D4AF37', marginBottom: '1rem' }}>
        💱 Pares vs Real
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {mainPairs.map((item, i) => (
          <DataRow 
            key={i}
            theme={theme}
            label={item.symbol}
            subLabel={item.name}
            price={`R$ ${item.last_quote?.toFixed(4)}`}
            change={`${item.isIncrement ? '+' : ''}${item.rate?.toFixed(2)}%`}
            isPositive={item.isIncrement}
          />
        ))}
      </div>
    </div>
  );
};

// METAIS CARD - Metals from commodities
export const MetaisCard = ({ theme, limit }) => {
  const { data, loading } = useCommodities();

  if (loading) return <div style={{ height: '300px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }} />;
  if (!data) return <div>No commodity data</div>;

  const metalNames = {
    'GC=F': 'Ouro',
    'SI=F': 'Prata',
    'PL=F': 'Platina',
    'PA=F': 'Paládio',
    'HG=F': 'Cobre',
    'ALI=F': 'Alumínio'
  };

  const metals = data
    .filter(c => ['GC=F', 'SI=F', 'PL=F', 'PA=F', 'HG=F', 'ALI=F'].includes(c.symbol))
    .slice(0, limit || 6);

  return (
    <div style={{
      background: theme.cardBg,
      borderRadius: '12px',
      padding: '1.5rem',
      border: `1px solid ${theme.border}`,
      backdropFilter: 'blur(10px)',
      height: '100%'
    }}>
      <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#D4AF37', marginBottom: '1rem' }}>
        ⚡ Metais
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {metals.map((item, i) => (
          <DataRow 
            key={i}
            theme={theme}
            label={metalNames[item.symbol] || item.name}
            subLabel={item.symbol}
            price={`$${item.last_quote?.toFixed(2) || item.close?.toFixed(2)}`}
            change={`${item.isIncrement ? '+' : ''}${item.rate?.toFixed(2)}%`}
            isPositive={item.isIncrement}
          />
        ))}
      </div>
    </div>
  );
};